import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { ObjectLiteral } from 'src/app/_models/user';
import { LanguageService } from 'src/app/_services/api/language/language.service';

@Component({
  selector: 'ua-flight-card',
  templateUrl: './flight-card.component.html',
  styleUrls: ['./flight-card.component.scss']
})
export class FlightCardComponent implements OnInit {

  showBaggageStatus: boolean = false;
  languageSubscription: Subscription;
  pageConstants: ObjectLiteral;

  constructor(private languageService: LanguageService) {
    this.languageSubscription = this.languageService.languageChanges.subscribe(() => {
      this.pageConstants = this.languageService.constants?.flightDetails || {};
    })
  }

  @Input('flightDetails') flightDetails: any;
  @Input('isExpanded') isExpanded: boolean = false;
  @Input('hideMoreInformation') hideMoreInformation: boolean = false;
  @Output('moreInfo') moreInfoEmitter = new EventEmitter();

  ngOnInit(): void {
    this.showBaggageStatus = this.flightDetails?.legStatus == 'ARRIVED_AT_GATE' && this.flightDetails?.isFinalDestination;
  }

  onMoreInformation(){
    this.moreInfoEmitter.emit();
  }

}
